module.exports = __webpack_public_path__ + "img/shengchan.84483264.png";